var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { hexToU8a } from '@polkadot/util';
export class PolkaJsSigner {
    constructor(signingAccount) {
        this._signingAccount = signingAccount;
    }
    sign(data) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let sig;
            if (!this._signingAccount || !((_a = this._signingAccount) === null || _a === void 0 ? void 0 : _a.account)) {
                throw new Error('no signing account was provided to sign the data with keyring');
            }
            else {
                let { account, signer } = this._signingAccount;
                if (signer && signer.signRaw) {
                    let { signature } = yield signer.signRaw({
                        address: account.address,
                        data: data,
                        type: 'bytes',
                    });
                    sig = hexToU8a(signature);
                }
                else {
                    sig = account.sign(data);
                }
            }
            if (!sig) {
                throw new Error('empty signiture is not valid.');
            }
            return sig;
        });
    }
}
